import L from 'leaflet';

const PREVIEW_MAP_CENTER = { lat: -22.9068, lng: -43.1729 };

/** Cache da lista ativa ordenada por identidade do array de configuração. */
const sortedActiveStatusCache = new WeakMap();

function isActiveFlag(value) {
    return Number(value) === 1;
}

function isEmptyGuia(idGuia) {
    return idGuia == null || idGuia === '' || Number(idGuia) === 0;
}

function matchesStatus(codStatus, veiculo, context) {
    switch (codStatus) {
        case 'validador_offline':
            return isActiveFlag(veiculo.validador_offline);
        case 'gps_offline':
            return isActiveFlag(veiculo.gps_offline);
        case 'sem_guia':
            return context.hasGuias && isEmptyGuia(veiculo.id_guia);
        case 'guia_inconsistente':
            return !isEmptyGuia(veiculo.id_guia) && (
                String(veiculo.id_linha) !== String(veiculo.id_linha_guia) ||
                String(veiculo.cod_motorista_veiculo) !== String(veiculo.id_motorista_guia) ||
                String(veiculo.cod_cobrador_veiculo) !== String(veiculo.id_cobrador_guia)
            );
        case 'sem_viagem_prevista':
            return !isEmptyGuia(veiculo.id_viagem) && isActiveFlag(veiculo.sem_viagem_prevista);
        case 'viagem_ida':
            return !isEmptyGuia(veiculo.id_viagem) && Number(veiculo.sentido) === 0;
        case 'viagem_volta':
            return !isEmptyGuia(veiculo.id_viagem) && Number(veiculo.sentido) === 1;
        case 'em_rota':
            return true;
        default:
            return false;
    }
}

/**
 * Retorna status ativos ordenados por prioridade, memoizado pela identidade de `statusConfig`.
 */
export function getSortedActiveStatus(statusConfig) {
    if (!statusConfig || statusConfig.length === 0) {
        return [];
    }
    const cached = sortedActiveStatusCache.get(statusConfig);
    if (cached) {
        return cached;
    }
    const sorted = statusConfig
        .filter((s) => Number(s.ativo) !== 0)
        .sort((a, b) => Number(a.prioridade) - Number(b.prioridade));
    sortedActiveStatusCache.set(statusConfig, sorted);
    return sorted;
}

export function resolveVeiculoStatus(veiculo, statusConfig, context) {
    const sorted = getSortedActiveStatus(statusConfig);
    if (sorted.length === 0) {
        return null;
    }

    for (const status of sorted) {
        if (matchesStatus(status.cod_status, veiculo, context)) {
            return status;
        }
    }

    return null;
}

export function getVeiculoCor(veiculo, statusConfig, context) {
    const status = resolveVeiculoStatus(veiculo, statusConfig, context);
    return status ? status.cor : 'transparent';
}

export function isVeiculoVisibleOnMap(veiculo, statusConfig, context, selectedVeiculoId) {
    if (selectedVeiculoId != null && veiculo.id_veiculo === selectedVeiculoId) {
        return true;
    }

    const status = resolveVeiculoStatus(veiculo, statusConfig, context);
    if (!status) {
        return true;
    }

    return Number(status.visivel) === 1;
}

export function createVeiculoOperacaoMapIcon(color, { size = 30, blink = false, title = 'Online' } = {}) {
    const classname = blink ? 'my-custom-pin blink' : 'my-custom-pin';
    const width = String(size);
    const height = String(size);

    return L.divIcon({
        className: classname,
        html: `<svg width="${width}" height="${height}" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg"><title>${title}</title>
                <path opacity="0.1" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" fill="${color}"/>
                <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="${color}" stroke-width="2"/>
                <path d="M15 13L12.2014 10.2014V10.2014C12.0901 10.0901 11.9099 10.0901 11.7986 10.2014V10.2014L9 13" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`,
        iconAnchor: [15, 15],
        tooltipAnchor: [0, -15],
    });
}

export function buildPreviewVeiculos(statusList) {
    if (!statusList || statusList.length === 0) {
        return [];
    }

    const sorted = [...statusList].sort((a, b) => Number(a.prioridade) - Number(b.prioridade));

    return sorted.map((status, index) => ({
        isPreview: true,
        id_veiculo: `preview-${status.cod_status}`,
        cod_veiculo: `PREV-${String(index + 1).padStart(2, '0')}`,
        cod_status: status.cod_status,
        descricao: status.descricao,
        lat: PREVIEW_MAP_CENTER.lat + index * 0.001,
        lng: PREVIEW_MAP_CENTER.lng + index * 0.001,
        cor: status.cor || 'transparent',
        visivel: Number(status.visivel) ? 1 : 0,
        ativo: Number(status.ativo !== undefined && status.ativo !== null ? status.ativo : 1) ? 1 : 0,
    }));
}
